import { Controller } from "@hotwired/stimulus"
import { tick } from "svelte";

function numberToCurrency(value) {
  return Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  }).split(".")[0];
}

export default class extends Controller {
  static values = {
    title: String,
    height: Number,
    series: Array, // {name, data}
  };

  connect = async () => {
    const { default: ApexCharts } = await import("apexcharts")
    // A turbo navigation can disconnect us while the import is in flight; don't
    // render onto a detached element (ApexCharts would throw).
    if (!this.element.isConnected) return

    let series = this.seriesValue

    // ApexCharts requires all series to have the same number of data points or tooltips will only render for one or
    // the other. I'd rather the line just end, but this is the only way to get around it for now.
    // A series with no points yet (no volume so far this month) has nothing to extend from; leave it empty.
    for (let s of series) {
      if (s.data.length === 0) continue

      while (s.data.length < 31) {
        const last = s.data[s.data.length - 1];
        s.data.push({x: last.x + 1, y: last.y});
      }
    }

    let chart = new ApexCharts(this.element, {
      chart: {
        type: 'line',
        height: this.heightValue,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        }
      },
      grid: {
        borderColor: "#444",
        clipMarkers: false,
        xaxis: {
          lines: {
            show: true

          },
        },
        yaxis: {
          lines: {
            show: true
          },
        },
      },
      title: {
        text: this.titleValue,
        align: 'left',
      },
      series: series,
      theme: {
        mode: 'dark'
      },
      yaxis: {
        min: 0,
        labels: {
          formatter: function(val, loa) {
            return numberToCurrency(val)
          },
        },
        format: function(val) {
          return numberToCurrency(val)
        },
        title: {
          text: 'Amount'
        },
        opposite: true,
      }
    })

    chart.render()
  }
}
